<template>
  <div>
    <div class="line-wrap">
      <div class="line-1">
        <div v-for="(item, index) in list" :key="index + 'id'">
          <div
            v-if="swiperindex == 0 || swiperindex == 2"
            :class="swiperindex == index ? 'line lineactive' : 'line whiteLine'"
          ></div>
          <div
            v-else
            :class="
              swiperindex == index ? 'line lineactive2' : 'line whiteLine'
            "
          ></div>
        </div>
      </div>
    </div>
    <div class="img-1ogo-warp">
      <img
        class="img-1ogo"
        :src="
          swiperindex == 0 || swiperindex == 2
            ? 'http://www.heywoods.cn/newImage/2-logo.png'
            : 'http://www.heywoods.cn/newImage/2-logo-black.png'
        "
      />
    </div>

    <div class="reference">
      <p>
        <a
          :class="
            swiperindex == 0 || swiperindex == 2 ? 'whiteColor' : 'blackColor'
          "
          href="http://www.beian.miit.gov.cn"
          >广州小黑屋科技有限公司 版权所有</a
        >
      </p>
      <p>
        <a
          :class="
            swiperindex == 0 || swiperindex == 2 ? 'whiteColor' : 'blackColor'
          "
          href="http://beian.miit.gov.cn"
          >粤ICP备17009904号-1</a
        >
      </p>
      <p>
        <img src="../../images/jin.png" class="jinhui" />
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010502002393"
          :class="
            swiperindex == 0 || swiperindex == 2 ? 'whiteColor' : 'blackColor'
          "
          >粤公网安备 44010502002391号</a
        >
      </p>
    </div>
    <div class="remind" v-if="swiperindex != 5" @click="slideTo">
      <img
        class="remindAni"
        :src="
          swiperindex == 0 || swiperindex == 2
            ? 'http://www.heywoods.cn/newImage/3.png'
            : 'http://www.heywoods.cn/newImage/13.png'
        "
      />
    </div>
    <swiper v-bind:options="swiperOption" ref="mySwiper" id="swiperBox">
      <swiper-slide class="swiper-slide" id="swiper-slide">
        <div class="page-1">
          <div class="videoClass">
            <img
              class="videoClass"
              src="http://www.heywoods.cn/newImage/pc-p1-bk.jpg"
            />
          </div>
          <img
            class="img-1"
            src="http://www.heywoods.cn/newImage/pc-p1-word.jpg"
          />
        </div>
      </swiper-slide>

      <swiper-slide class="swiper-slide2" id="swiper-slide2">
        <div class="page-1">
          <div class="videoClass">
            <!-- <img class='videoClass' src="http://www.heywoods.cn/newImage/p2-bk.jpg"/> -->
            <img
              class="img-2-bg"
              src="http://www.heywoods.cn/newImage/p2-bk-pic-bg.jpg"
            />
          </div>

          <img
            class="img-2"
            src="http://www.heywoods.cn/newImage/p2-word.png"
          />
        </div>
      </swiper-slide>

      <swiper-slide class="swiper-slide3" id="swiper-slide3">
        <div class="page-3">
          <div class="page-2-header" style="position: absolute; top: 12%">
            <div class="page-2-title">
              <span style="color: white">企业文化</span>
            </div>
            <div class="page-2-info" style="color: white">Culture</div>
          </div>
          <img class="page-3-img" src="http://www.heywoods.cn/newImage/6.png" />
          <div class="page-3-img2-warp">
            <img
              id="page-3-img"
              :class="
                swiperindex == 2 ? 'page-3-Ani page-3-img2' : 'page-3-img2'
              "
              src="http://www.heywoods.cn/newImage/culture.jpg"
            />
          </div>
        </div>
      </swiper-slide>

      <swiper-slide class="swiper-slide4" id="swiper-slide4">
        <div class="page-4">
          <img
            class="miniproImg-4"
            src="http://www.heywoods.cn/newImage/7.png"
          />
          <div class="page-2-content">
            <div class="page-2-content-wrap" style="width: 100%">
              <div class="page-2-header">
                <div class="page-2-title">
                  <span>员工福利</span>
                </div>
                <div class="page-2-info">Staff Welfare</div>
              </div>
            </div>
          </div>
          <div class="page-4-img" id="page-4-img-fa">
            <img
              id="page-4-img"
              :class="swiperindex == 3 ? 'page-4-Ani' : ''"
              src="http://www.heywoods.cn/newImage/staff.jpg"
            />
          </div>
        </div>
      </swiper-slide>

      <swiper-slide class="swiper-slide5" id="swiper-slide5">
        <div class="page-5" style="background: #f7f7f7">
          <img
            class="miniproImg-5"
            src="http://www.heywoods.cn/newImage/8.png"
          />
          <div class="page-2-content">
            <div class="page-2-content-wrap">
              <div class="page-2-header">
                <div class="page-2-title">
                  <span>人才招聘</span>
                </div>
                <div class="page-2-info">Recruitment</div>
              </div>

              <div class="page-5-rec">
                <div
                  v-for="(item, index) in recArrTitle"
                  v-bind:key="index + 'id'"
                >
                  <div class="page-5-title" @click="tabClick(index)">
                    <p class="title">
                      {{ item
                      }}<span
                        :class="itemIndex == index ? 'borderActive' : ''"
                      ></span>
                    </p>
                  </div>
                </div>
                <div
                  v-for="(item, index) in recArrContent"
                  class="page-2-info-list"
                  v-show="itemIndex == index"
                  v-bind:key="index + 'id'"
                >
                  <div
                    v-for="(item2, index2) in item.content"
                    v-bind:key="index2 + 'id'"
                  >
                    <p class="page-2-info-list-item">
                      {{ index2 + 1 }}、{{ item2 }}
                    </p>
                  </div>
                </div>
                <div class="page-5-end">
                  <span class="line-gray"></span>
                  <div>
                    简历请发送到邮箱：hr@heywoods.cn<span class="color-gray"
                      >（邮件请标注职位+姓名）</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>

      <swiper-slide class="swiper-slide6" id="swiper-slide6">
        <div class="page-6">
          <div class="page-2-content-wrap" id="page-2-content">
            <img
              class="miniproImg-6"
              src="http://www.heywoods.cn/newImage/9.png"
            />
            <div class="page-2-header" style="padding-bottom: 9%">
              <div class="page-2-title">
                <span>社会责任</span>
                <div></div>
                <span>公益</span>
              </div>
              <div class="page-2-info">Social Responsibility</div>
            </div>
            <div class="page-6-content">
              <div class="page-6-content-img">
                <img
                  :class="swiperindex == 5 ? 'page-6-Ani' : ''"
                  src="http://www.heywoods.cn/newImage/gy-pc.png"
                />
              </div>
              <div class="page-6-content-info">
                <p>
                  小黑屋已经连续3年参与彩虹助学计划，到云南腾冲帮助那里的孩子们。
                </p>
                <div>
                  他们很多成长过程其实都不完整，我们能够尽量帮助他们解决生活上的需求，却还没有办法更好的解决心理上的问题。或许我们每期的活动只能改变一点点，但是只要坚持下去，就会有复利产生。
                </div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Vue from "vue";
var times = null;
var times2 = null;
const baseSize = 10;
var scroll = 0;
// 改变窗口大小时重新设置 re
export default {
  name: "PcIndex",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      imgArr: [],
      WindowHeight: "",
      itemIndex: 0,
      recArrTitle: ["PHP开发", "产品", "运营", "客服"],
      recArrContent: [
        {
          content: [
            "本科及以上学历，计算机相关专业，1-4年PHP互联网软件相关工作；",
            "熟练使用PHP开发，熟悉至少两种以上框架：Phalcon、Swoole、 Laravel、Yaf；",
            "熟悉Linux下的常用分布式架构方案，并能根据业务对系统及软件进行性能调优；",
            "熟悉NoSQL，熟练使用Redis、Mongo等常用非关系型数据库；",
            "熟练使用git、walle、jenkins等版本控制和代码部署工具；",
            "熟悉golang、高并发编程、微服务及docker容器技术优先；",
            "有高并发及海量数据处理经验者优先。",
          ],
        },
        {
          content: [
            "本科以上学历，有产品视角，能独立负责产品设计和规划，良好的需求分析及挖掘能力；",
            "有自我驱动的学习精神，能理解技术原理并明白如何落地；",
            "有较强的沟通能力，并协调资源高效地解决问题；",
            "熟悉微信开发优先，特别是小程序项目；",
            "有电商/社区/论坛/社交类产品项目经验。",
          ],
        },
        {
          content: [
            "有公众号运营/内容编辑经验，有一定的文字功底，擅长拟标题；",
            "具备用户思维，擅长流量转化；",
            "具备PS、视频剪辑技能优先考虑；",
            "工作细心、有上进心、有责任感；",
          ],
        },
        {
          content: [
            "要求普通话标准，能听懂部分地方方言优先；",
            "拥抱变化，为人正直，有责任心；",
            "学习能力强，做事积极主动；",
            "接受优秀实习生和应届生。",
          ],
        },
      ],
      list: ["", "", "", "", "", ""],
      enterIndex: "",
      swiperindex: 0,
      swiperOption: {
        //					 swiper configs 所有的配置同swiper官方api配置
        preventClicksPropagation: true, //阻止click冒泡。拖动Swiper时阻止click事件。
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        //					height: window.innerHeight, // 高度设置，强制占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
        //					 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        debugger: true,
        //					 swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        onTransitionStart(swiper) {
          console.log(swiper, "vvvvvvv");
        },
        on: {
          //监听滑动切换事件，返回swiper对象
          slideChange: () => {
            let self = this;
            let swiper = this.$refs.mySwiper.swiper;
            this.swiperindex = swiper.activeIndex;
            let currentwidth =
              window.innerWidth ||
              document.documentElement.clientWidth ||
              document.body.clientWidth;
            console.log(swiper.activeIndex); //滑动打印当前索引
          },
        },
      },
      proArr: [
        {
          img: "http://www.heywoods.cn/newImage/zynh.png",
          name: "战友你好",
          erm: "http://www.heywoods.cn/newImage/zynh-1.png",
          hidden: false,
        },
        {
          img: "http://www.heywoods.cn/newImage/点开就看.jpg",
          name: "点开就看",
          erm: "http://www.heywoods.cn/newImage/点开就看1.jpeg",
          hidden: false,
        },
        {
          img: "http://www.heywoods.cn/newImage/花花鸟鸟.jpg",
          name: "花花鸟鸟",
          erm: "http://www.heywoods.cn/newImage/花花鸟鸟1.jpeg",
          hidden: false,
        },
        {
          img: "http://www.heywoods.cn/newImage/象集.jpg",
          name: "象集",
          erm: "http://www.heywoods.cn/newImage/象集1.jpg",
          hidden: false,
        },
        {
          img: "http://www.heywoods.cn/newImage/珍贵图片集.jpg",
          name: "珍贵图片集",
          erm: "http://www.heywoods.cn/newImage/珍贵图片集1.jpeg",
          hidden: false,
        },
      ],
    };
  },
  computed: {
    swiper() {
      console.log(this.$refs.mySwiper.swiper, "this.$refs.mySwiper.swiper");
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    let self = this;
    console.log("this is current swiper instance object", this.swiper);
    this.swiper.slideTo(0, 1000, false); //初始滑动到哪个页面
    // document.getElementById("videoid").play()
    this.setRem();
    window.onresize = function () {
      self.setRem();
    };
  },
  created: function () {},
  methods: {
    slideTo: function () {
      this.swiper.slideTo(this.swiperindex + 1, 1000, true); //初始滑动到哪个页面
    },
    setRem: function () {
      // 当前页面宽度相对于1280宽的缩放比例，可根据自己需要修改。1280是设计稿的宽度
      const scale = document.documentElement.clientWidth / 1280;
      let autoWidth = Math.round(baseSize * Math.min(scale, 2));
      console.log(autoWidth, "autoWidth");
      //			    console.log(autoWidth,'autoWidthautoWidth')
      //判断页面缩放到小于99px的字体时 就不再缩小 防止内容溢出
      if (Math.round(baseSize * Math.min(scale, 2)) <= 6) {
        autoWidth = 6;
      } else if (Math.round(baseSize * Math.min(scale, 2)) > 10) {
        autoWidth = 10;
      }
      // 设置页面根节点字体大小
      document.documentElement.style.fontSize = autoWidth + "px";
      this.WindowHeight = autoWidth;
      let test = document.documentElement.clientHeight;

      document.getElementById("swiper-slide").style.height =
        document.documentElement.clientHeight + "px";
      document.getElementById("swiper-slide2").style.height =
        document.documentElement.clientHeight + "px";
      document.getElementById("swiper-slide3").style.height =
        document.documentElement.clientHeight + "px";
      document.getElementById("swiper-slide4").style.height =
        document.documentElement.clientHeight + "px";
      document.getElementById("swiper-slide5").style.height =
        document.documentElement.clientHeight + "px";
      document.getElementById("swiper-slide6").style.height =
        document.documentElement.clientHeight + "px";
      document.getElementById("swiper-slide").parentNode.style.height =
        document.documentElement.clientHeight + "px";
      scroll = -document.documentElement.clientHeight * this.swiperindex;
      document.getElementById("swiper-slide").parentNode.style.transform =
        "translate3d(0px," + scroll + "px," + "0px)";
      console.log(
        test,
        document.documentElement.clientHeight,
        document.getElementById("swiper-slide").parentNode,
        "document.documentElement.clientHeight"
      );
    },
    tabClick: function (index) {
      this.itemIndex = index;
    },
    enter: function (index) {
      console.log(index, "ggggg");
      this.proArr[index].hidden = true;
    },
    leave: function () {
      console.log("离开");
      for (var i = 0; i < this.proArr.length; i++) {
        this.proArr[i].hidden = false;
      }
    },
    getWidth: function () {
      var currentwidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      $("#introduce img").attr("width", currentwidth * 3);
      $("#introduce").scrollLeft(currentwidth);
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body,
html {
  margin: 0px;
  height: 100%;
}

.swiper {
  width: 100%;
  height: 100%;
}

swiper-slide {
  width: 100%;
  height: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.swiper-slide1,
.swiper-slide2,
.swiper-slide3,
.swiper-slide4,
.swiper-slide5,
.swiper-slide6 {
  position: relative;
  width: 100%;
  height: auto;
  left: 0;
  top: 0;
}

.page-1,
.page-2,
.page-3,
.page-4,
.page-6,
.page-5 {
  position: relative;
  width: 100%;
  left: 0;
  top: 0;
  height: inherit;
  z-index: 3;
}

.img-1 {
  z-index: 2;
  position: absolute;
  top: 35%;
  left: 83px;
}
.img-2 {
  z-index: 2;
  position: absolute;
  top: 30%;
  left: 83px;
}

.page-2-title {
  font-weight: bold;
  display: flex;
  flex-flow: row;
  height: 42px;
  align-items: center;
  color: #000000;
}

.page-3-img {
  position: absolute;
  z-index: 3;
  right: 10%;
  bottom: 20%;
}

.page-4-img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  width: 80%;
  height: 52%;
}

.page-4-img > img {
  width: 108%;
  max-height: 100%;
}

.page-5-rec {
  position: absolute;
  width: 90%;
  margin-left: 12%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.page-2-info-list {
  clear: left;
  width: 100%;
  padding-top: 20px;
  /*min-height: 40%;*/
}

.page-5-title {
  float: left;
  width: 25%;
  font-family: "宋体";
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
}

.title {
  display: inline;
  position: relative;
  z-index: 1;
}

.borderActive {
  position: absolute;
  height: 15px;
  left: 0;
  width: 100%;
  background: rgba(85, 192, 52, 0.35);
  bottom: -3px;
  z-index: -2;
}

.page-2-info-list-item {
  font-family: "宋体";
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  width: 100%;
}

.page-5-end {
  left: 0%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  z-index: 3;
  font-weight: bold;
  font-size: 1.8rem;
  color: rgba(51, 51, 51, 1);
}

.line-gray {
  display: block;
  width: 40%;
  min-width: 220px;
  height: 2px;
  background: #979797;
  margin-right: 15px;
}

.color-gray {
  font-size: 1.4rem;
  font-weight: normal;
  color: #333333;
}

.img-1ogo-warp {
  position: fixed;
  height: 60px;
  left: 83px;
  top: 3%;
  z-index: 2;
}

.img-1ogo {
  position: absolute;
  width: 80px;
  height: 74px;
  left: 0px;
  top: 0px;
  z-index: 2;
}

.page-2-content {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
}

.page-2-content-wrap {
  width: 80%;
  height: inherit;
  margin: 0 auto;
}

.page-2-header {
  z-index: 3;
  position: absolute;
}

.miniproImg-6 {
  position: absolute;
  right: 7%;
  top: 97px;
}

.line-wrap {
  position: fixed;
  z-index: 2;
  right: 54px;
  max-width: 36px;
}
.page-6-content {
  position: absolute;
  top: 55%;
  left: 50%;
  width: 80%;
  transform: translate(-50%, -50%);
  overflow: hidden;
}
.page-6-content-img {
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  width: 123%;
  overflow: hidden;
}
.page-6-Ani {
  animation: walk6Ani 26s linear infinite;
}
@keyframes walk6Ani {
  0% {
    left: 0;
    position: absolute;
  }
  50% {
    left: -23%;
    position: absolute;
  }
  100% {
    left: 0;
    position: absolute;
  }
}
.page-6-content-img > img {
  max-height: 100%;
  margin-left: 15px;
}

.page-6-content-info {
  width: 100%;
}

.page-6-content-info > p {
  font-size: 1.8rem;
  color: black;
  font-weight: bold;
}

.page-6-content-info > div {
  font-size: 1.6rem;
  color: #555555;
}
@media screen and (min-width: 1680px) {
  /*对应PC端页面*/
  .img-1 {
    width: 946px;
    height: 201px;
  }
  .img-2 {
    width: 749px;
    left: 83px;
  }
  .page-2-title {
    font-size: 3.5rem;
  }
  .page-3-img {
    width: 383px;
    height: 181px;
  }
  .page-5-title {
    font-size: 2.6rem;
    height: 5rem;
    line-height: 5rem;
  }
  .page-2-info-list-item {
    font-size: 2.2rem;
    line-height: 2.6rem;
  }
  .img-1ogo-warp {
    height: 60px;
    left: 83px;
    top: 3%;
  }
  .img-1ogo {
    width: 64px;
    height: 60px;
  }
  .page-2-header {
    padding-top: 3%;
    left: 83px;
  }
  .page-2-content-wrap {
    padding-top: 96px;
  }
  .miniproImg-6 {
    width: 284px;
    height: 143px;
    top: 97px;
  }
  .line-wrap {
    top: 105px;
  }
  .page-2-info-list {
    min-height: 350px;
  }
  .page-6-content-img {
    height: 250px;
  }
  .page-6-content-info {
    margin-top: 5rem;
  }
}

@media screen and (max-width: 1680px) and (min-width: 1280px) {
  /*对应PC端页面*/
  .img-1 {
    width: 593px;
    height: 126px;
    left: 73px;
  }
  .img-2 {
    width: 659px;
    left: 73px;
  }
  .page-2-title {
    font-size: 2.5rem;
  }

  .page-3-img {
    width: 211.6px;
    height: 100px;
  }
  .page-5-title {
    font-size: 2rem;
    height: 3rem;
    line-height: 3rem;
  }
  .page-2-info-list-item {
    font-size: 1.6rem;
    line-height: 2rem;
  }
  .img-1ogo-warp {
    height: 50px;
    left: 73px;
    top: 3%;
  }
  .img-1ogo {
    width: 54px;
    height: 50px;
  }
  .page-2-header {
    padding-top: 0%;
    left: 73px;
  }
  .page-2-content-wrap {
    padding-top: 86px;
  }
  .miniproImg-6 {
    width: 224.5px;
    height: 113px;
    top: 57px;
  }
  .line-wrap {
    top: 5%;
  }
  .page-2-info-list {
    min-height: 300px;
  }
  .page-6-content-img {
    height: 200px;
  }
  .page-6-content-info {
    margin-top: 3rem;
  }
}

@media screen and (max-width: 1280px) and (min-width: 1024px) {
  /*对应PC端页面*/
  .img-1 {
    width: 593px;
    height: 126px;
    left: 73px;
  }
  .img-2 {
    width: 579px;
    left: 73px;
  }
  .page-2-title {
    font-size: 2.5rem;
  }
  .page-3-img {
    width: 211.6px;
    height: 100px;
  }
  .page-5-title {
    font-size: 2rem;
    height: 3rem;
    line-height: 3rem;
  }
  .page-2-info-list-item {
    font-size: 1.6rem;
    line-height: 2rem;
  }
  .img-1ogo-warp {
    height: 50px;
    left: 73px;
    top: 3%;
  }
  .img-1ogo {
    width: 54px;
    height: 50px;
  }
  .page-2-header {
    padding-top: 0%;
    left: 73px;
  }
  .page-2-content-wrap {
    padding-top: 76px;
  }
  .miniproImg-6 {
    width: 185px;
    height: 93px;
    top: 37px;
  }
  .line-wrap {
    top: 3%;
  }
  .page-2-info-list {
    min-height: 250px;
  }
  .page-6-content-img {
    height: 150px;
  }
  .page-6-content-info {
    margin-top: 1.5rem;
  }
}

@media screen and (max-width: 1024px) {
  /*对应PC端页面*/
  .img-1 {
    width: 47.1%;
    height: 10%;
    left: 63px;
  }
  .img-2 {
    width: 509px;
    left: 63px;
  }
  .page-2-title {
    font-size: 1.5rem;
  }

  .page-3-img {
    width: 21.16%;
    height: 10%;
  }
  .page-5-title {
    font-size: 1.5rem;
    height: 2rem;
    line-height: 2rem;
  }
  .page-2-info-list-item {
    font-size: 1.2rem;
    line-height: 1.5rem;
  }
  .img-1ogo-warp {
    height: 40px;
    left: 63px;
    top: 3%;
  }
  .img-1ogo {
    width: 44px;
    height: 40px;
  }
  .page-2-header {
    padding-top: 66px;
    left: 63px;
  }
  .miniproImg-6 {
    width: 145px;
    height: 73px;
    top: 17px;
  }
  .line-wrap {
    top: 1%;
  }
  .page-2-info-list {
    min-height: 200px;
  }
  .page-6-content-img {
    height: 100px;
  }
  .page-6-content-info {
    margin-top: 1rem;
  }
}

.line-1 {
  position: relative;
  width: 100%;
}

.line {
  margin-bottom: 24px;
  width: 24px;
  right: 0;
  height: 3px;
  float: right;
  background: rgba(255, 255, 255, 0.35);
}

.whiteLine {
  background: rgba(147, 147, 147, 0.35);
}

.lineactive {
  width: 36px;
  background: rgba(255, 255, 255, 1);
}

.lineactive2 {
  width: 36px;
  background: rgba(147, 147, 147, 1);
}

@keyframes lineAni {
  0% {
    width: 0%;
  }
  30% {
    width: 30%;
  }
  60% {
    width: 60%;
  }
  100% {
    width: 100%;
  }
}

.videoClass {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: fill;
}
.img-2-bg {
  position: absolute;
  z-index: 0;
  right: 0;
  /* width: 38%; */
  height: 100%;
  bottom: 0;
}

.reference {
  position: absolute;
  text-align: left;
  z-index: 2;
  bottom: 12px;
  left: 55px;
}

.reference > p {
  display: block;
  line-height: 6px;
  font-size: 12px;
}

.whiteColor {
  color: white;
}

.blackColor {
  font-family: PingFangSC;
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
}

.remind {
  width: 50px;
  height: 29px;
  position: fixed;
  bottom: 18px;
  z-index: 2;
  left: 50%;
  transform: translate(-50%, 0);
}

.remind > img {
  width: 50px;
  height: 29px;
}

.remindAni {
  animation: removeAni 2s 1.5s linear infinite forwards;
}

@keyframes removeAni {
  0% {
    opacity: 1;
    transform: translateY(-10px);
  }
  50% {
    opacity: 1;
    transform: translateY(0px);
  }
  100% {
    opacity: 0;
    transform: translateY(-10px);
  }
}

.swiper-slide2 {
  background: white;
}

.miniproImg {
  position: absolute;
  right: 0;
  width: 729px;
  height: 148px;
  top: 44px;
  z-index: 2;
}

.miniproImg-4 {
  position: absolute;
  right: 0;
  width: 723px;
  height: 149px;
  top: 22px;
  z-index: 2;
}

.miniproImg-5 {
  position: absolute;
  right: 0;
  width: 712px;
  height: 148px;
  top: 22px;
  z-index: 2;
}

.page-2-title > div {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: black;
  margin-left: 6px;
  margin-right: 6px;
  line-height: 4.2rem;
}

.page-2-title > img {
  width: 42px;
  height: 42px;
  margin-left: 10px;
}

.page-2-info {
  color: #55c034;
  font-size: 1.6rem;
  font-weight: normal;
  line-height: 30px;
}

.page-2-pro {
  width: 100%;
  height: 100%;
}

.page-3-img2-warp {
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.jinhui {
  width: 17px;
  height: 17px;
  position: relative;
  top: -1px;
  left: -1px;
}

.page-3-img2 {
  position: absolute;
  width: 180%;
  height: inherit;
}

@media (max-width: 1000px) {
}

.page-3-Ani {
  animation: walkAni 30s linear infinite forwards;
}

.page-4-Ani {
  animation: walk2Ani 16s linear infinite;
}

@keyframes walkAni {
  0% {
    left: 0;
    position: absolute;
  }
  50% {
    left: -80%;
    position: absolute;
  }
  100% {
    left: 0;
    position: absolute;
  }
}

@keyframes walk2Ani {
  0% {
    left: 0;
    position: absolute;
  }
  50% {
    left: -8%;
    position: absolute;
  }
  100% {
    left: 0;
    position: absolute;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PcIndex.vue